/**
 * 後台「懸浮 Leo 對話」開關與最小化狀態（跨頁共用，非 Vuex）。
 * 以 bus 事件同步各元件；開關持久化於 localStorage。
 */
import Vue from 'vue'

export const leoFloatDockBus = new Vue()

const LS_OPEN = 'leo_admin_float_dock_open'
const LS_MIN = 'leo_admin_float_dock_min'
const LS_POS = 'leo_admin_float_dock_pos'

let _open = false
let _minimized = false

function readOpenFromStorage () {
  if (typeof localStorage === 'undefined') return
  try {
    _open = localStorage.getItem(LS_OPEN) === '1'
    _minimized = localStorage.getItem(LS_MIN) === '1'
  } catch (e) {}
}

export function initLeoFloatDockFromStorage () {
  readOpenFromStorage()
  leoFloatDockBus.$emit('sync')
}

export function getLeoFloatDockOpen () {
  return _open
}

export function setLeoFloatDockOpen (v) {
  _open = !!v
  if (!_open) {
    _minimized = false
    try {
      localStorage.removeItem(LS_MIN)
    } catch (e) {}
  }
  try {
    localStorage.setItem(LS_OPEN, _open ? '1' : '0')
  } catch (e) {}
  leoFloatDockBus.$emit('sync')
}

export function getLeoFloatDockMinimized () {
  return _minimized
}

export function setLeoFloatDockMinimized (v) {
  _minimized = !!v
  try {
    localStorage.setItem(LS_MIN, _minimized ? '1' : '0')
  } catch (e) {}
  leoFloatDockBus.$emit('sync')
}

function readLayoutRaw () {
  if (typeof localStorage === 'undefined') return null
  try {
    const raw = localStorage.getItem(LS_POS)
    if (!raw) return null
    const o = JSON.parse(raw)
    return o && typeof o === 'object' ? o : null
  } catch (e) {
    return null
  }
}

function writeLayoutRaw (next) {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(LS_POS, JSON.stringify(next))
  } catch (e) {}
}

/** @returns {{ left: number, top: number }|null} */
export function getLeoFloatDockPosition () {
  const o = readLayoutRaw()
  if (!o) return null
  const left = Number(o.left)
  const top = Number(o.top)
  if (Number.isNaN(left) || Number.isNaN(top)) return null
  return { left, top }
}

/** @returns {{ width: number, height: number }|null} */
export function getLeoFloatDockPanelSize () {
  const o = readLayoutRaw()
  if (!o) return null
  const width = Number(o.width)
  const height = Number(o.height)
  if (Number.isNaN(width) || Number.isNaN(height) || width < 1 || height < 1) return null
  return { width, height }
}

export function setLeoFloatDockPosition (left, top) {
  const o = readLayoutRaw() || {}
  o.left = left
  o.top = top
  writeLayoutRaw(o)
}

/** 與座標寫入同一 JSON，保留未傳入之欄位 */
export function setLeoFloatDockPanelSize (width, height) {
  const o = readLayoutRaw() || {}
  o.width = width
  o.height = height
  writeLayoutRaw(o)
}



// WEBPACK FOOTER //
// ./src/utils/leoAdminFloatDock.js